import {
  getLeadMetaAPI,
  LeadMetaParsedData,
} from '@services/new/common/getLeadMeta';
import {QueryClient, useQuery} from '@tanstack/react-query';

export const getLeadMetaQueryKey = () => ['leadMeta'];

export const getLeadMetaQueryFn = () => getLeadMetaAPI().send;

export const prefetchLeadMeta = async (queryClient: QueryClient) => {
  const response = await getLeadMetaQueryFn()();
  await queryClient.prefetchQuery({
    queryKey: getLeadMetaQueryKey(),
    queryFn: () => response,
  });
  return response;
};
const useLeadMetaQuery = () => {
  return useQuery<LeadMetaParsedData>({
    queryKey: getLeadMetaQueryKey(),
    queryFn: getLeadMetaQueryFn(),
    staleTime: Infinity,
  });
};

export default useLeadMetaQuery;
